import "./CreateTag.css";

import {
  Breadcrumb,
  Button,
  Checkbox,
  ColorPicker,
  Form,
  Input,
  message,
} from "antd";
import { useEffect } from "react";
import { BsTrash } from "react-icons/bs";
import { CgScreen } from "react-icons/cg";
import { Link, useLocation, useNavigate } from "react-router-dom";

import {
  createTag,
  deleteTag,
  type TagFormType,
  updateTag,
  useAppSelector,
} from "../../../_lib/_store";

interface CreateTagPageProps {
  type: "create" | "edit";
}

export const CreateTagPage = ({ type }: CreateTagPageProps) => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const { isLoading } = useAppSelector((state) => state.tag);
  const navigate = useNavigate();
  const { state } = useLocation();

  const isEdit = type === "edit";

  useEffect(() => {
    const tagObj = state?.tag;
    if (isEdit && !tagObj) {
      navigate("/tag");
    }
    if (isEdit) {
      form.setFieldsValue(tagObj);
    }
  }, [state]);

  const handleSubmit = async (values: TagFormType) => {
    const payload = {
      ...values,
      ...(isEdit ? { id: state.tag.id } : {}),
    };

    if (isEdit) {
      const res = await updateTag(messageApi, payload);
      if (res) {
        navigate("/tag/edit", {
          state: { tag: res },
          replace: true,
        });
      }
    } else {
      const res = await createTag(messageApi, payload);
      if (res) {
        form.resetFields();
      }
    }
  };

  const handleDelete = async () => {
    const res = await deleteTag(messageApi, state.tag.id);
    if (res) {
      navigate("/tag");
    }
  };

  return (
    <>
      {contextHolder}
      <div className="createPackage">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: <Link to="/tag">Tag</Link>,
            },
            {
              title: isEdit ? "Edit" : "Create new",
            },
          ]}
        />

        {!isEdit ? (
          <h2 className="title">Create new</h2>
        ) : (
          <div className="titleHeader">
            <h2 className="title">Edit</h2>
            <div className="actionButton">
              <Button
                icon={<CgScreen size={17} />}
                size="large"
                onClick={() =>
                  navigate(`/tag/show`, {
                    state: { tag: state?.tag },
                  })
                }
              >
                Show
              </Button>
              <Button
                icon={<BsTrash />}
                size="large"
                onClick={handleDelete}
                loading={isLoading}
              >
                Delete
              </Button>
            </div>
          </div>
        )}

        <div className="form">
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            initialValues={{ isActive: true }}
          >
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "Name is required" }]}
              tooltip="Tag name (must be unique)."
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item label="Display Name" name="displayName">
              <Input size="large" />
            </Form.Item>

            <Form.Item label="Description" name="description">
              <Input size="large" />
            </Form.Item>

            <Form.Item
              label="Color"
              name="color"
              getValueFromEvent={(color) => color.toHexString()}
            >
              <ColorPicker
                size="large"
                showText={(color) => color.toHexString()}
                format="hex"
              />
            </Form.Item>

            <Form.Item label="Category" name="category">
              <Input size="large" />
            </Form.Item>

            <Form.Item label="" name="isActive" valuePropName="checked">
              <Checkbox>Is Active</Checkbox>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                style={{ width: "150px" }}
                loading={isLoading}
              >
                {isEdit ? "Update" : "Save"}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </>
  );
};
